/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/21/17
 * Copyright All Rights Reserved
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import NavLinkGroup from 'components/NavLinkGroup';
import SignOutLink from 'containers/SignOutLinkContainer';
import SP3Logo from 'components/SP3Logo';

const Header = ({ inApp }) => {
  const logo = inApp ? <SP3Logo /> : <Link to="sign-in"><SP3Logo /></Link>;
  const nav = inApp
      ? (
        <NavLinkGroup className="pull-right">
          <ul>
            <li><Link to="/list" > View Reports </Link></li>
            <li>|</li>
            <li><Link to="/inputs" > Create Report </Link></li>
            <li>|</li>
            <li><SignOutLink /></li>
          </ul>
        </NavLinkGroup>
        )
      : (
        <NavLinkGroup className="pull-right">
          <ul>
            <li><Link to="/sign-in" > Sign In </Link></li>
          </ul>
        </NavLinkGroup>
        )
    ;
  return (
    <header className="header navbar-fixed-top">
      {logo}
      <span className="product-name"> SP3 - Site Hazards</span>
      <span className="product-attribution"> by Haselton Baker Risk Group</span>
      {nav}
    </header>
  );
};

Header.defaultProps = {
  inApp: true,
};

Header.propTypes = {
  inApp: PropTypes.bool,
};

export default Header;
